import React, { useState } from "react";
import { Modal, Form, DatePicker, Alert, message } from "antd";
import dayjs, { Dayjs } from "dayjs";
import { ScheduleOperation } from "../../../serviceoperation/ScheduleOperation";

interface CloneScheduleModalProps {
  open: boolean;
  onClose: () => void;
  onClone: (targetDate: Date) => void;
  sourceWeek: Date;
  corpId: number;
}

const CloneScheduleModal: React.FC<CloneScheduleModalProps> = ({
  open,
  onClose,
  onClone,
  sourceWeek,
  corpId,
}) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState<boolean>();

  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      const values = await form.validateFields();

      // Get the Current Weeks Schedule.
      // Should this be pulled from the prior page? Propbably a good idea yeah or no?
      const scheduleOps = new ScheduleOperation();
      scheduleOps
        .postScheduleCloneAsync(
          corpId,
          dayjs(sourceWeek).format("YYYY-MM-DD"),
          dayjs(values.targetWeek.toDate()).format("YYYY-MM-DD")
        )
        .then((x) => {
          const success =
            x.statusCode != undefined && x.statusCode.toString() === "201";

          if (success) {
            // Copy the Current Weeks Schedule to next week.
            onClone(values.targetWeek.toDate());
            onClose();
            form.resetFields();
          } else {
            message.success(
              "An error has occured while processing your request!"
            );
          }
          setIsLoading(false);
        });
    } catch (error) {
      message.success("An error has occured while processing your request!");
      setIsLoading(false);
      console.error("Validation failed:", error);
    }
  };

  return (
    <Modal
      title="Clone Weekly Schedule"
      confirmLoading={isLoading}
      open={open}
      onCancel={onClose}
      onOk={handleSubmit}
      okText="Clone Schedule"
    >
      <Alert
        message={`Clone schedule from week of ${dayjs(sourceWeek).format(
          "MMMM D, YYYY"
        )}`}
        type="info"
        showIcon
      />

      <Form form={form} layout="vertical">
        <Form.Item
          name="targetWeek"
          label="Select Target Week"
          rules={[{ required: true, message: "Please select a target week" }]}
        >
          <DatePicker
            picker="week"
            disabledDate={(current: Dayjs) => {
              const currentWeekStart = current.startOf("week");
              const todayWeekStart = dayjs().startOf("week");
              return (
                currentWeekStart.isSame(todayWeekStart, "day") ||
                currentWeekStart.isBefore(todayWeekStart, "day")
              );
            }}
            style={{ width: "100%" }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CloneScheduleModal;
